import { useForm } from 'react-hook-form';
import TextField from '../Reusable/Form/TextInput';
import Button from '../Reusable/Button';
import APIS from '../../constant/EndPoint';
import usePatchHook from '../../customHooks/useUserServicePatchHook';

const UpdateUserProfile = (props: any) => {
  const { user } = props
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError
  } = useForm<any>({
    defaultValues: async () => {
      // let data: any = await props?.refetch()
      return {
        ...user?.profile
      }
    }
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.PROFILE}${user.profile?.id}/`;
    let formData = {
      ...values,
      email: props?.profile?.user_info?.email ?? props?.email
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <form onSubmit={handleSubmit((data: any) => handleUpdateProfile(data, setError))} autoComplete="off">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
          <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.email}
          />
          <TextField
            label={"Alt Email"}
            register={register("email")}
            errors={errors?.email}
          />
          <TextField
            label={"Alt Mobile NUmber"}
            register={register("contact_number")}
            errors={errors?.mobile_number}
          />
        </div>
        <div className="flex justify-end w-full">
          <div className="w-[100px] mr-4">
            <Button label={"Update"} isLoading={false} />
          </div>
        </div>
      </form>
    </>
  )
}

export default UpdateUserProfile